import React from "react";

import { Link } from "react-router-dom";

export default function DeleteAccount() {
  return (
    <div className="min-h-screen mesh-bg">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <Link to="/" className="text-sm text-emerald-600">
          ← Back to home
        </Link>

        <div className="card-soft p-8 mt-6">
          <h1 className="font-display text-4xl font-bold">Account Deletion</h1>

          <p className="mt-2 text-sm text-slate-500">Last updated: May 2026</p>

          <div className="prose prose-slate dark:prose-invert max-w-none mt-8">
            <section className="space-y-4">
              <h2 className="text-2xl font-bold">
                Requesting Account Deletion
              </h2>

              <p>
                AccessWealth allows users to permanently request deletion of
                their account and associated personal data.
              </p>

              <p>Users may request account deletion through:</p>

              <ul className="space-y-2">
                <li>In-app account deletion options in settings tab</li>
                <li>Email support requests</li>
              </ul>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">How To Delete Your Account</h2>

              <p>
                To request deletion of your AccessWealth account, send an email
                from your registered email address to:
              </p>

              <p className="font-semibold text-emerald-600">
                info@accesswealth.in
              </p>

              <p>Please include:</p>

              <ul className="space-y-2">
                <li>Your registered email address</li>
                <li>Your registered phone number </li>
                <li>Subject line: "Account Deletion Request"</li>
              </ul>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">
                What Happens After Deletion
              </h2>

              <p>Once your deletion request is verified and processed:</p>

              <ul className="space-y-2">
                <li>Your account access will be permanently disabled</li>
                <li>Your stored financial records may be deleted</li>
                <li>Your vault documents may be permanently removed</li>
                <li>Family linking and nominee connections may be removed</li>
                <li>Associated authentication sessions may be revoked</li>
              </ul>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">Data Retention</h2>

              <p>
                Certain information may be retained for legal, fraud-prevention,
                compliance, security, dispute resolution, or regulatory purposes
                where required by applicable law.
              </p>

              <p>
                Backup systems and audit logs may retain limited information for
                a temporary period before permanent removal.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">Processing Time</h2>

              <p>
                Verified deletion requests are generally processed within a
                reasonable timeframe depending on account activity, security
                review requirements, and legal obligations.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">Contact</h2>

              <p>For deletion requests or account-related concerns, contact:</p>

              <p className="font-semibold text-emerald-600">
                info@accesswealth.in
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
